import { useLocation, useNavigate, useParams } from 'react-router-dom';
import CourseData from '../../../data/course/CourseData.json';
import Layout from '../../../common/Layout';

const CourseDetails = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const navigate = useNavigate();
    const selectedMeetFromQuery = searchParams.get("meet");
    // const selectedMeetFromState = location.state?.selectedMeet || null;

    const { id } = useParams();
    const courseId = parseInt(id, 10);
    const data = CourseData.filter(course => course.id === courseId);
    const courseItem = data[0];

    return (
        <Layout>
            <section className="course-detail-wrapper">
                <div className="tutori-course-content tab-style-1">
                    <div className="container">
                        <div className="row">
                            <div className="course-sidebar col-lg-7 col-xl-8">
                                <div className="course-widget">
                                    <button
                                        type="button"
                                        className="btn btn-link text-danger d-inline-flex align-items-center mb-3 px-0"
                                        onClick={() => navigate('/course')}
                                    >
                                        {/* <MdArrowBack className="me-2" /> */}
                                        Back to Courses
                                    </button>
                                    <h1 className="course-title mb-4">{courseItem.title}</h1>
                                    <img className='img-fluid' alt='course-detail' src={`/assets/images/course/course-detail/${courseItem.image}`}></img>
                                    <div className="tab-content tutori-course-content">
                                        {/* Overview Tab */}
                                        <div className={`tab-pane fade show active`}>
                                            <div className="single-course-details ">
                                                <div className="mt-4 course-tab-content paragraph" dangerouslySetInnerHTML={{ __html: courseItem.details }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    )
}
export default CourseDetails;